// extracted by mini-css-extract-plugin
export var completionBody = "_cl-2";
export var completionCard = "_cl-0";
export var completionFooter = "_cl-3";
export var completionTitle = "_cl-1";